import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AnnouncementsContext = createContext();

export const AnnouncementsProvider = ({ children }) => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  const parseDotNetDate = (dotNetDate) => {
    if (!dotNetDate) return new Date();
    const timestamp = parseInt(dotNetDate.replace(/[^0-9]/g, ""));
    return new Date(timestamp);
  };

  const formatDate = (dotNetDate) => {
    const date = parseDotNetDate(dotNetDate);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  };

  const fetchAnnouncements = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/Home/GetAnnouncementsApi`
      );

      if (res.data.status === "Success") {
        // Sort by date descending
        const sorted = res.data.data.sort((a, b) => {
          const dateA = parseDotNetDate(a.Date || a.Created_Date);
          const dateB = parseDotNetDate(b.Date || b.Created_Date);
          return dateB - dateA;
        });

        const formatted = sorted.map(item => ({
          ...item,
          formattedTitle: item.Title,
          formattedDate: formatDate(item.Date || item.Created_Date),
          link: item.Url || "#",

        }));

        // Duplicate items if needed for continuous scrolling (like in NewsContext)
        setAnnouncements(formatted);
      }
    } catch (error) {
      console.error("Error fetching announcements:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  return (
    <AnnouncementsContext.Provider value={{ announcements, loading, fetchAnnouncements }}>
      {children}
    </AnnouncementsContext.Provider>
  );
};

export const useAnnouncements = () => useContext(AnnouncementsContext);



